import React from 'react'
import { useEffect, useState } from 'react'

const Timer = (props) => {
    const { initialMinute = 0, initialSecond = 0 } = props
    const [minutes, setMinutes] = useState(initialMinute)
    const [seconds, setSeconds] = useState(initialSecond)

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                if (seconds <= 0) {
                    if (minutes <= 0) {
                        props.isTimerClosed && props.isTimerClosed()
                        clearInterval(myInterval)
                    } else {
                        setMinutes(minutes - 1)
                        setSeconds(59)
                    }
                }
                if (minutes <= 0 && seconds <= 1) {
                    props.isTimerClosed && props.isTimerClosed()
                    clearInterval(myInterval)
                }
            }
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    }, [minutes, seconds, props.isTimerClosed]);

    return (
        <span className="">
            {minutes <= 0 && seconds <= 0 ? null :
                <span>  Please try after
                    <span style={{ color: "#ff5555", padding: 'auto 3px' }}> {minutes}: {seconds < 10 ? `0${seconds}` : seconds}</span>
                    seconds </span>
            }
        </span>
    )
}

export default Timer